import React, { useEffect, useRef, useState, useMemo } from "react";
import styled from "styled-components";
import { isUndefined } from "lodash";
import { Severity } from "entities/Console";
import FilterHeader from "./FilterHeader";
import {
  BlankState,
  useFilteredExecutionLogs,
  useFilteredLogs,
  usePagination,
} from "./helpers";
import LogItem, { getLogItemProps } from "./LogItem";
import ExecutionComponents from "./ExecutionComponents";
import { width } from "styled-system";

const LIST_HEADER_HEIGHT = "38px";

const ContainerWrapper = styled.div`
  overflow: hidden;
  height: 100%;
`;
const ContainerTest = styled.div`
  position: fixed;
  top: 48px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 55;
`;
const ListWrapper = styled.div`
  overflow: auto;
  height: calc(100% - ${LIST_HEADER_HEIGHT});
`;

type Props = {
  searchQuery: string;
  hasShortCut?: boolean;
};

const LOGS_FILTER_OPTIONS = [
  {
    label: "All",
    value: "",
  },
  { label: "Success", value: Severity.INFO },
  { label: "Warnings", value: Severity.WARNING },
  { label: "Errors", value: Severity.ERROR },
  { label: "Execution", value: Severity.EXECUTION },
];

function ExecutionLogs(props: Props) {
  const [filter, setFilter] = useState("");
  const [openExecution, setOpenExecution] = useState(false);
  const [executionData, setExecutionData] = useState(false);
  const [searchQuery, setSearchQuery] = useState(props.searchQuery);
  const filteredLogs = useFilteredExecutionLogs(searchQuery, filter);
  const { next, paginatedData } = usePagination(filteredLogs);
  const listRef = useRef<HTMLDivElement>(null);
  const selectedFilter = useMemo(
    () => LOGS_FILTER_OPTIONS.find(option => option.value === filter),
    [filter],
  );

  const handleScroll = (e: Event) => {
    if ((e.target as HTMLDivElement).scrollTop === 0) {
      next();
    }
  };

  useEffect(() => {
    const list = listRef.current;
    if (!list) return;
    list.addEventListener("scroll", handleScroll);
    return () => list.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const list = listRef.current;
    if (list) {
      setTimeout(() => {
        list.scrollTop = list.scrollHeight - list.clientHeight;
      }, 0);
    }
  }, [paginatedData.length]);

  return (
    <ContainerWrapper>
      {openExecution && (
        <ContainerTest>
          <ExecutionComponents
            executionData={executionData}
            close={setOpenExecution}
          />
        </ContainerTest>
      )}
      {/*<FilterHeader*/}
      {/*  defaultValue={props.searchQuery}*/}
      {/*  onChange={setSearchQuery}*/}
      {/*  onSelect={value => !isUndefined(value) && setFilter(value)}*/}
      {/*  options={LOGS_FILTER_OPTIONS}*/}
      {/*  searchQuery={searchQuery}*/}
      {/*  selected={selectedFilter || LOGS_FILTER_OPTIONS[0]}*/}
      {/*/>*/}

      <ListWrapper className="debugger-list" ref={listRef}>
        {!paginatedData.length ? (
          <BlankState hasShortCut={!!props.hasShortCut} />
        ) : (
          paginatedData.map((e, index: number) => {
            const logItemProps = getLogItemProps(e);

            return (
              <LogItem
                key={`debugger-${index}`}
                {...logItemProps}
                expand={index === paginatedData.length - 1}
                click={(e: any) => {
                  setOpenExecution(true);
                  setExecutionData(e);
                }}
              />
            );
          })
        )}
      </ListWrapper>
    </ContainerWrapper>
  );
}

// Set default props
ExecutionLogs.defaultProps = {
  searchQuery: "",
};

export default ExecutionLogs;
